










































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import { IShareConfigState } from '~/store/share/types';
import GalaBalanceWidget from '~/components/Home/Widgets/GalaBalanceWidget.vue';
import IncompleteAccountWidget from '~/components/Home/Widgets/IncompleteAccountWidget.vue';
import GoldUpgradeWidget from '~/components/Home/Widgets/GoldUpgradeWidget.vue';
import GetANodeWidget from '~/components/Home/Widgets/GetANodeWidget.vue';
import DiscordWidget from '~/components/Home/Widgets/DiscordWidget.vue';

@Component({
  components: {
    GalaBalanceWidget,
    IncompleteAccountWidget,
    GoldUpgradeWidget,
    GetANodeWidget,
    DiscordWidget,
  },
})
export default class WelcomeBanner extends Vue {
  galaGoldImg = require(`@/assets/gold/ribbon_GG.png`);

  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State(inventory => inventory.isFetchingWallets, { namespace: 'inventory' })
  isFetchingWallets!: IUser;

  @State(profile => profile.user.goldMember, { namespace: 'profile' })
  readonly goldMember!: boolean;

  @Getter('showBuyCoinScreens') readonly showBuyCoinScreens!: boolean;

  @Getter('galaBalance', { namespace: 'inventory' })
  readonly galaBalance!: number;

  townstarImg = require(`@/assets/townstar_inventory.png`);

  get bottomRowWidgetOptions() {
    return {
      goldUpgrade: {
        title: this.$t('common.cta.becomeAGoldMember') as string,
        component: GoldUpgradeWidget,
      },
      getANode: {
        title: this.$t('common.cta.getAGalaNode') as string,
        component: GetANodeWidget,
      },
      discord: {
        title: this.$t('common.cta.joinOurCommunity') as string,
        component: DiscordWidget,
      },
    };
  }

  get isFetchingBalance() {
    return !this.galaBalance && this.isFetchingWallets;
  }

  get showUpgradeWidget() {
    const { walletExists, walletConnected } = this.currentUser;
    return (walletExists || walletConnected) && !this.goldMember;
  }

  get bottomRowWidgetsDisplayed() {
    const { goldUpgrade, getANode, discord } = this.bottomRowWidgetOptions;
    const widgetOrder: Array<{ title: string; component: any }> = [
      getANode,
      discord,
    ];
    if (this.currentUser.discordProfile) {
      widgetOrder.pop();
    }
    if (this.showUpgradeWidget) {
      widgetOrder[0] = goldUpgrade;
    }
    return widgetOrder;
  }

  handlePlayClick() {
    if (
      this.currentUser.isInBlockedCountry &&
      this.currentUser.shouldBlockGameplay
    ) {
      return;
    }
    if (process.env.displayGameInIframe) {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
      } else if ((document.body as any).webkitRequestFullscreen) {
        (document.body as any).webkitRequestFullscreen();
      }
    }

    this.$router.push(`/games/town-star/play`);
  }
}
